import { useEffect, useRef, useState } from "react";

interface Props {
  value: number;
  prefix?: string;
  className?: string;
}

export default function AnimatedNumber({ value, prefix = "", className = "" }: Props) {
  const [display, setDisplay] = useState(value);
  const prevRef = useRef(value);

  useEffect(() => {
    const from = prevRef.current;
    const to = value;
    if (from === to) return;
    prevRef.current = to;

    const steps = 20;
    const diff = to - from;
    let step = 0;
    const timer = setInterval(() => {
      step++;
      setDisplay(Math.round(from + (diff * step) / steps));
      if (step >= steps) clearInterval(timer);
    }, 16);
    return () => clearInterval(timer);
  }, [value]);

  return (
    <span className={className}>
      {prefix}{display}
    </span>
  );
}
